import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FILTER_ICON } from 'src/defaultImages.js';

@Component({
  selector: 'app-mpos-filter-button',
  templateUrl: './mpos-filter-button.component.html',
  styleUrls: ['./mpos-filter-button.component.css'],
})
export class MposFilterButtonComponent implements OnInit, OnDestroy {
  @Input() filterData: any;
  @Output() filterResult: EventEmitter<any> = new EventEmitter<any>();

  images = {
    FILTER_ICON,
  };
  subscription: Subscription = new Subscription();
  translationText: any;
  selectedFilterCount: number = 0;

  constructor(private _dialog: MatDialog,   private _translateService: TranslateService) {}

  ngOnInit(): void {
    this.setTranslations();
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setTranslations(): void {
    this.subscription.add(
      this._translateService.get('MPOS_FILTERS').subscribe((translation) => {
        this.translationText = translation.MPOS_FILTERS || {};
      })
    );
  }

  async filterBtnClicked() {
    const { MposFilterComponent } = await import(
      /* webpackPrefetch: true */ '../../shared modal/mpos-filter/mpos-filter.component'
    );
    const modal = this._dialog.open(MposFilterComponent, {
      backdropClass: 'backdrop',
      panelClass: 'full-width-dialog',
      data: this.filterData,
    });
    
    modal.afterClosed().subscribe((results) => {
      if ((results || {}).status === 1) {
        const filtersData = (results || {}).data || [];
        this.filterResult.emit(results);
        this.updateSelectedOptionsCount(filtersData);
      }
    });
  }

  private updateSelectedOptionsCount(filtersData) {
    const selectedFiltersOptions =
      filtersData.filter(
        (filter) => ((filter || {}).selectedOptionsCount || 0) > 0
      ) || [];
    this.selectedFilterCount = selectedFiltersOptions.length;
  }
}
